import { useMutation } from '@tanstack/react-query';
import api from '~/api';
import { useClaim } from '~/features/claimReview/ClaimReviewProvider';
import { Timeline } from '~/features/timeline/Timeline';
import { useStoreId } from '~/providers/StoreUserProvider';

export default function ClaimTimeline() {
  const storeId = useStoreId();
  const claim = useClaim();

  const { id, timeline: events = [] } = claim;

  const { mutateAsync: addTimelineEvent, isPending } = useMutation({
    mutationFn: api.store(storeId).claim(`${id}`).addTimelineEvent,
    onSuccess: () => claim.refetch(),
  });

  return (
    <Timeline
      events={events}
      addEvent={addTimelineEvent}
      isPending={isPending}
      inputId="claim-timeline-comment"
    />
  );
}
